const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  rewardRecord ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/facebook/reward-record', { params })
  },
  groupJoinReward ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/facebook/group-join-reward', {
      params,
      noShowError: true,
    })
  },
  reissueLinksCreate ({ state, commit, rootState }, params) {
    return rootState.axios.post('/coin/v1frontend/facebook/reissue-links-create', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
